import { get } from './fetch'

export interface Vendor {
  address1: string
  address3: string
  address2: string
  city: string
  /* eslint-disable @typescript-eslint/naming-convention */
  contact_first_name: string
  contact_last_name: string
  contact_phone_number: string
  vendor_name: string
  postal_code: string
  vendor_code: string
  address_code: string
  tax_id: string
  /* eslint-enable @typescript-eslint/naming-convention */
  state: string
}

export const cache: { results: Vendor[] | null } = { results: null }

export async function getVendors() {
  const { results } = cache.results
    ? cache
    : await (get('vendors') as Promise<{ results: Vendor[] }>)
  cache.results = results || []
  return results
}
